import { render, staticRenderFns } from "./cuantitativa.vue?vue&type=template&id=575e1659&lang=html"
import script from "./cuantitativa.vue?vue&type=script&lang=js"
export * from "./cuantitativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports